import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Icons } from '../../shared/helpers/icons';
import { environment } from '../../environments/environment';
import { NsideIdentityService } from '../../shared/services/auth/nSideIdentityService';

export type SidebarMode = 'large' | 'small';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  icons = Icons;
  pageRoute = '';

  @Input() mode: SidebarMode = 'large';
  @Output() modeChange = new EventEmitter<SidebarMode>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    private identity: NsideIdentityService
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.updatePageRoute());
    this.updatePageRoute();
  }

  // Read the first URL segment directly. Walking ActivatedRoute.firstChild
  // returns the empty parent route's path ('') for nested route trees, and
  // `'' ?? fallback` doesn't trigger — `??` only fires on null/undefined.
  private updatePageRoute(): void {
    const path = this.router.url.split(/[?#]/)[0];
    this.pageRoute = path.split('/').filter(Boolean)[0] ?? '';
  }

  navigateToPage(route: string): void {
    this.router.navigate([route]);
  }

  openIdentity(): void {
    window.open(environment.identityUrl + '/admin/users', '_blank', 'noopener');
  }

  openPlatform(): void {
    window.open(environment.nSidePlatformUrl, '_blank', 'noopener');
  }

  logout(): void {
    this.identity.logout();
  }

  toggle(): void {
    const next: SidebarMode = this.mode === 'large' ? 'small' : 'large';
    this.mode = next;
    this.modeChange.emit(next);
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('admin_tools.sidebar_mode', next);
    }
  }
}
